<template>
    <v-container grid-list-lg>
        <v-layout>
            <v-flex>
                <h4 class="headline">SMS-historikk / kø</h4>
                <v-layout wrap>
                </v-layout>
            </v-flex>
            <v-flex shrink align-self-center>
                <v-btn color="orange" @click="emptySmsQueue">
                    Tøm SMS-kø
                    <v-icon right>backspace</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
        <SmsList :items-per-page="100" ref="list"></SmsList>
    </v-container>
</template>

<script>
import SmsList from "@/components/helpers/SmsList";

export default {
    components: {
        SmsList
    },

    methods: {
        emptySmsQueue() {
            let ok = confirm('Vil du slette alle meldinger som ligger i sendingskøen? Bruk dette hvis du f.eks. vil avbryte en SMS-kampanje etter at den er startet.');
            if (!ok) return;

            this.$http.delete(`sms/queue`).then(response => {
                this.$refs['list'].loadData();
                this.$root.addMessage('Meldinger som lå i sendingskøen er nå slettet.', 'green');
            });
        }
    },
}
</script>

<style scoped>

</style>
